import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIForm from 'UIComponents/form/UIForm';
import UITextArea from 'UIComponents/input/UITextArea';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { INSIGHT_FEEDBACK_CATEGORIES } from 'messaging-publishing-lib/Insights/constant/insightFeedback';
import styled from 'styled-components';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TextArea = styled(UITextArea).withConfig({
  displayName: "FeedbackTooltipDetail__TextArea",
  componentId: "sc-21ccit-0"
})(["font-size:12px;"]);
const CategoriesTitle = styled(FormattedMessage).withConfig({
  displayName: "FeedbackTooltipDetail__CategoriesTitle",
  componentId: "sc-21ccit-1"
})(["font-size:14px;"]);
export default function FeedbackTooltipDetail({
  selectedCategories,
  sentiment,
  handleCategoryChange,
  onClose,
  onSubmit,
  onFeedbackTextChange,
  feedbackText,
  feedbackProps
}) {
  return /*#__PURE__*/_jsxs(UIForm, {
    className: "m-top-4",
    onSubmit: e => {
      e.preventDefault();
      trackInsightsInteraction(Object.assign({}, feedbackProps, {
        otherAction: 'submit',
        insightFeedbackSentiment: sentiment,
        insightFeedbackCategories: selectedCategories
      }));
      onSubmit();
    },
    children: [/*#__PURE__*/_jsx(CategoriesTitle, {
      message: "messaging-insights.insights.feedback.categories.title"
    }), /*#__PURE__*/_jsx(UIButtonWrapper, {
      className: "m-top-4 m-bottom-6",
      justify: "start",
      children: INSIGHT_FEEDBACK_CATEGORIES[sentiment].map(category => {
        const isSelected = selectedCategories.includes(category);
        return /*#__PURE__*/_jsx(UIButton, {
          use: isSelected ? 'tertiary-light' : 'tertiary-extra-light',
          size: "extra-small",
          onClick: () => {
            if (!isSelected) {
              trackInsightsInteraction(Object.assign({}, feedbackProps, {
                otherAction: 'select-category',
                insightFeedbackSentiment: sentiment,
                insightFeedbackCategory: category
              }));
            }
            handleCategoryChange(getUpdateSelectedCategories(category));
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `messaging-insights.insights.feedback.categories.text.${category}`
          })
        }, category);
      })
    }), /*#__PURE__*/_jsx(TextArea, {
      defaultValue: feedbackText,
      placeholder: I18n.text('messaging-insights.insights.feedback.textAreaPlaceholder'),
      onChange: ({
        currentTarget: {
          value
        }
      }) => onFeedbackTextChange(value)
    }), /*#__PURE__*/_jsxs(UIButtonWrapper, {
      justify: "end",
      className: "m-top-5",
      children: [/*#__PURE__*/_jsx(UIButton, {
        size: "sm",
        use: "secondary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.feedback.cancelButton"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        size: "sm",
        type: "submit",
        disabled: !selectedCategories.length && !feedbackText,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.feedback.submitButton"
        })
      })]
    })]
  });
}
function getUpdateSelectedCategories(feedbackCategory) {
  return prevSelectedCategories => prevSelectedCategories.includes(feedbackCategory) ? prevSelectedCategories.filter(category => category !== feedbackCategory) : [...prevSelectedCategories, feedbackCategory];
}